import { Loading } from "@/components/common/Loading";
import { RemunerationService } from "@/service/services/Remuneration.service";
import { readLocalStorage, removeLocalStorage } from "@/toolbox/helpers/local-storage-helper";
import { Alert, Autocomplete, Button, Container, Grid, Snackbar, TextField } from "@mui/material";
import { useEffect, useState } from "react";
// import { Props } from "./PDF.type"


export const CertificateEmployeeView: React.FC<any> = (props:any): JSX.Element => {
    // const { pdf, dataRemu, idEmploye } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [btnSave, setBtnSave] = useState<boolean>(true);
    const [snackBarConfig, setSnackBarConfig] = useState<any>({
        open: false,
        severity: 'error',
        message: 'Error',
        autoHideDuration: 3000,
    });
    console.log(props)
    const data = readLocalStorage('CertificateEmployee');
    console.log(data)

    const [dataPDF, setDataPDF] = useState<any>(data?.pdf)
    console.log(dataPDF)
    return (
        <>
        {loading && <Loading/>}
        <Snackbar
            open={snackBarConfig.open} 
            autoHideDuration={snackBarConfig.autoHideDuration} 
            onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
            anchorOrigin={{ vertical: 'top', horizontal:'right' }} >
            <Alert onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))} severity={snackBarConfig.severity}>
                {snackBarConfig.message || ""}
            </Alert>
        </Snackbar>
        <Grid container style={{ overflow: 'hidden !important', height:'100%', alignItems: 'center', textAlign: 'center'}}>
             <iframe src={dataPDF} id="pdfVer" height="1000px" width="100%"></iframe>
            
        </Grid>
        </>
    )
}